// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/modules/select2-3.5.3/select2.css
// module id = 814
// module chunks = 1